<script>
import UploadList from './upload-list';
import Upload from './upload';
import ElProgress from 'element-ui/lib/progress';
import Migrating from 'element-ui/lib/mixins/migrating';

function noop () {}

export default {
  name: 'RtUpload',

  components: {
    ElProgress,
    UploadList,
    Upload
  },

  mixins: [Migrating],

  provide () {
    return {
      uploader: this
    };
  },

  inject: {
    elForm: {
      default: ''
    }
  },

  props: {
    action: {
      type: String,
      required: true
    },
    headers: {
      type: Object,
      default () {
        return {};
      }
    },
    data: Object,
    multiple: Boolean,
    name: {
      type: String,
      default: 'file'
    },
    drag: Boolean,
    dragger: Boolean,
    withCredentials: Boolean,
    showFileList: {
      type: Boolean,
      default: true
    },
    accept: String,
    type: {
      type: String,
      default: 'select'
    },
    beforeUpload: Function,
    beforeRemove: Function,
    onRemove: {
      type: Function,
      default: noop
    },
    onChange: {
      type: Function,
      default: noop
    },
    onPreview: {
      type: Function
    },
    onSuccess: {
      type: Function,
      default: noop
    },
    onProgress: {
      type: Function,
      default: noop
    },
    onError: {
      type: Function,
      default: noop
    },
    fileList: {
      type: Array,
      default () {
        return [];
      }
    },
    autoUpload: {
      type: Boolean,
      default: true
    },
    listType: {
      type: String,
      default: 'text' // text,picture,picture-card
    },
    httpRequest: Function,
    disabled: Boolean,
    limit: Number,
    onExceed: {
      type: Function,
      default: noop
    },
    // 拖拽自定义宽度
    dragWidth: {
      type: Number,
      default: 260
    },
    // 拖拽自定义高度
    dragHeight: {
      type: Number,
      default: 150
    },
    // 拖拽自定义圆角
    dragBorderRadius: {
      type: Number,
      default: 2
    },
    // 拖拽自定义边框,可选 base
    dragBorder: {
      type: String,
      default: 'dashed'
    },
    // 拖拽自定义边框颜色，可选 light
    dragBorderColor: {
      type: String,
      default: 'base'
    },
    // 拖拽自定义背景色，可选 lighter
    dragBgcolor: {
      type: String,
      default: 'white'
    },
    // 区域自定义宽度
    cardWidth: {
      type: Number,
      default: 120
    },
    // 区域自定义高度
    cardHeight: {
      type: Number,
      default: 120
    },
    // 区域自定义圆角
    cardBorderRadius: {
      type: Number,
      default: 0
    },
    // 拖拽自定义边框,可选 base
    cardBorder: {
      type: String,
      default: 'dashed'
    },
    // 拖拽自定义边框颜色，可选 light
    cardBorderColor: {
      type: String,
      default: 'base'
    },
    // 拖拽自定义背景色，可选 lighter
    cardBgcolor: {
      type: String,
      default: 'white'
    },
    // 手动上传 - 上传按钮位置
    manualUploadButton: {
      type: String,
      default: 'bottom'
    },
    // 是否启用成功/失败消息提示
    enableMessage: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      uploadFiles: [],
      dragOver: false,
      draging: false,
      tempIndex: 1
    };
  },

  computed: {
    /**
     * @deprecated
     */
    uploadDisabled () {
      return this.disabled || (this.elForm || {}).disabled;
    },
    computedDisabled () {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },

  watch: {
    listType (type) {
      if (type === 'picture-card' || type === 'picture') {
        this.uploadFiles = this.uploadFiles.map(file => {
          if (!file.url && file.raw) {
            try {
              file.url = URL.createObjectURL(file.raw);
            } catch (err) {
              console.error('[Element Error][Upload]', err);
            }
          }
          return file;
        });
      }
    },
    fileList: {
      immediate: true,
      handler (fileList) {
        this.uploadFiles = fileList.map(item => {
          item.uid = item.uid || Date.now() + this.tempIndex++;
          item.status = item.status || 'success';
          return item;
        });
      }
    }
  },

  beforeDestroy () {
    this.uploadFiles.forEach(file => {
      if (file.url && file.url.indexOf('blob:') === 0) {
        URL.revokeObjectURL(file.url);
      }
    });
  },

  methods: {
    handleStart (rawFile) {
      rawFile.uid = Date.now() + this.tempIndex++;
      let file = {
        status: 'ready',
        name: rawFile.name,
        size: rawFile.size,
        percentage: 0,
        uid: rawFile.uid,
        raw: rawFile
      };

      if (this.listType === 'picture-card' || this.listType === 'picture') {
        try {
          file.url = URL.createObjectURL(rawFile);
        } catch (err) {
          console.error('[Element Error][Upload]', err);
          return;
        }
      }

      this.uploadFiles.push(file);
      this.onChange(file, this.uploadFiles);
    },
    handleProgress (ev, rawFile) {
      const file = this.getFile(rawFile);
      this.onProgress(ev, file, this.uploadFiles);
      file.status = 'uploading';
      file.percentage = ev.percent || 0;
    },
    handleSuccess (res, rawFile) {
      const file = this.getFile(rawFile);

      if (file) {
        file.status = 'success';
        file.response = res;

        this.onSuccess(res, file, this.uploadFiles);
        this.onChange(file, this.uploadFiles);

        if (this.enableMessage) {
          this.$message({
            message: this.$tx('上传成功', 'xpc.uploadfile.uploadSuccess'),
            type: 'success'
          });
        }
      }
    },
    handleError (err, rawFile) {
      const file = this.getFile(rawFile);
      // const fileList = this.uploadFiles;

      file.status = 'fail';

      // fileList.splice(fileList.indexOf(file), 1);

      this.onError(err, file, this.uploadFiles);
      this.onChange(file, this.uploadFiles);

      if (this.enableMessage) {
        this.$message({
          message: this.$tx('上传失败', 'xpc.uploadfile.updownError'),
          type: 'error'
        });
      }
    },
    handleRemove (file, raw) {
      if (raw) {
        file = this.getFile(raw);
      }
      let doRemove = () => {
        this.abort(file);
        let fileList = this.uploadFiles;
        fileList.splice(fileList.indexOf(file), 1);
        this.onRemove(file, fileList);
      };

      if (!this.beforeRemove) {
        doRemove();
      } else if (typeof this.beforeRemove === 'function') {
        const before = this.beforeRemove(file, this.uploadFiles);
        if (before && before.then) {
          before.then(() => {
            doRemove();
          }, noop);
        } else if (before !== false) {
          doRemove();
        }
      }
    },
    getFile (rawFile) {
      let fileList = this.uploadFiles;
      let target;
      fileList.every(item => {
        target = rawFile.uid === item.uid ? item : null;
        return !target;
      });
      return target;
    },
    abort (file) {
      this.$refs['upload-inner'].abort(file);
    },
    clearFiles () {
      this.uploadFiles = [];
    },
    submit () {
      this.uploadFiles
        .filter(file => file.status === 'ready')
        .forEach(file => {
          this.$refs['upload-inner'].upload(file.raw);
        });
    },
    getMigratingConfig () {
      return {
        props: {
          'default-file-list': 'default-file-list is renamed to file-list.',
          'show-upload-list': 'show-upload-list is renamed to show-file-list.',
          'thumbnail-mode':
            'thumbnail-mode has been deprecated, you can implement the same effect according to this case: http://element.eleme.io/#/zh-CN/component/upload#yong-hu-tou-xiang-shang-chuan'
        }
      };
    }
  },

  render (h) {
    let uploadList;

    if (this.showFileList) {
      uploadList = (
        <UploadList
          disabled={this.computedDisabled}
          listType={this.listType}
          files={this.uploadFiles}
          on-remove={this.handleRemove}
          handlePreview={this.onPreview}
          cardWidth={this.cardWidth}
          cardHeight={this.cardHeight}
        >
          {props => {
            if (this.$scopedSlots.file) {
              return this.$scopedSlots.file({
                file: props.file
              });
            }
          }}
        </UploadList>
      );
    }

    const uploadData = {
      props: {
        type: this.type,
        drag: this.drag,
        action: this.action,
        multiple: this.multiple,
        'before-upload': this.beforeUpload,
        'with-credentials': this.withCredentials,
        headers: this.headers,
        name: this.name,
        data: this.data,
        accept: this.accept,
        fileList: this.uploadFiles,
        autoUpload: this.autoUpload,
        listType: this.listType,
        disabled: this.computedDisabled,
        limit: this.limit,
        'on-exceed': this.onExceed,
        'on-start': this.handleStart,
        'on-progress': this.handleProgress,
        'on-success': this.handleSuccess,
        'on-error': this.handleError,
        'on-preview': this.onPreview,
        'on-remove': this.handleRemove,
        'http-request': this.httpRequest,
        dragWidth: this.dragWidth,
        dragHeight: this.dragHeight,
        dragBorderRadius: this.dragBorderRadius,
        dragBorder: this.dragBorder,
        dragBgcolor: this.dragBgcolor,
        cardWidth: this.cardWidth,
        cardHeight: this.cardHeight,
        cardBorderRadius: this.cardBorderRadius,
        cardBorder: this.cardBorder,
        cardBgcolor: this.cardBgcolor
      },
      ref: 'upload-inner'
    };
    const defaultBtn = (
      <rt-button icon-name="rt-base-upload" size="16" type="primary">
        {this.$tx('点击上传', 'xpc.uploadfile.upload')}
      </rt-button>
    );
    const trigger = this.$slots.trigger || this.$slots.default || defaultBtn;
    const uploadComponent = <upload {...uploadData}>{trigger}</upload>;
    const manualUpload = <div class="rt-upload-manual-upload">{this.$slots.manual}</div>;

    return (
      <div class={['rt-upload', `rt-upload-manual-upload__${this.manualUploadButton}`, this.computedDisabled ? 'is-disabled' : '']}>
        {this.listType === 'picture-card' ? uploadList : ''}
        {this.$slots.trigger ? [uploadComponent, this.$slots.default] : uploadComponent}
        {this.manualUploadButton === 'right' ? manualUpload : ''}

        {this.$slots.tip}
        {this.listType !== 'picture-card' ? uploadList : ''}
        {this.manualUploadButton === 'bottom' ? manualUpload : ''}
      </div>
    );
  }
};
</script>



// WEBPACK FOOTER //
// rtUpload.vue?02516973